import dayjs from '@sancare/typescript-commons/src/misc/dayjs'

import {
  HomeChartStat,
  HomeChartStatsPayload,
  HomeStats,
  HomeStatsPayload,
  PredictionModel,
  PredictionModelType,
} from '@/home/types'

const DATE_FORMAT = 'DD-MM-YYYY'

/**
 * MCO renvoie l'intégralité des compteurs, SMR n'en renvoie qu'un sous-ensemble : tous les champs
 * sont donc optionnels côté wire, et comblés à 0 par le mapper.
 */
export type HomeStatsDtoIn = Partial<HomeStats>

export interface HomeChartStatDtoIn {
  year: number
  month: number
  week: number
  day: number
  countTotalStay: number
  countTodoStay: number
}

export interface PredictionModelDtoIn {
  name: string
  type: PredictionModelType
  version: string
  trainedAt: string | null
}

type HomeStatsDtoOut = {
  earlyLimit: string
  lateLimit: string
  pmsiType: string
  hospitalizationTypes: string
  medicalUnits?: string
}

type HomeChartStatsDtoOut = {
  mode: string
  unit: string
  earlyLimit: string
  lateLimit: string
  medicalUnits?: string
}

export function convertHomeStatsIn(rawStats: HomeStatsDtoIn): HomeStats {
  return {
    countTotalGlobalStay:          rawStats.countTotalGlobalStay ?? 0,
    countTodoGlobalStay:           rawStats.countTodoGlobalStay ?? 0,
    countNewCodingTotalStay:       rawStats.countNewCodingTotalStay ?? 0,
    countTodoNewCodingTotalStay:   rawStats.countTodoNewCodingTotalStay ?? 0,
    countDoneNewCodingTotalStay:   rawStats.countDoneNewCodingTotalStay ?? 0,
    countTotalOptimizableStay:     rawStats.countTotalOptimizableStay ?? 0,
    countOptimizableStay:          rawStats.countOptimizableStay ?? 0,
    countTodoOptimizableStay:      rawStats.countTodoOptimizableStay ?? 0,
    countTodoDasRevaluableStay:    rawStats.countTodoDasRevaluableStay ?? 0,
    countTodoDasIaRevaluableStay:  rawStats.countTodoDasIaRevaluableStay ?? 0,
    countTodoDpIaRevaluableStay:   rawStats.countTodoDpIaRevaluableStay ?? 0,
    countTotalQualityStay:         rawStats.countTotalQualityStay ?? 0,
    countTodoQualityStay:          rawStats.countTodoQualityStay ?? 0,
    countTodoNewCodingQualityStay: rawStats.countTodoNewCodingQualityStay ?? 0,
    countTodoDialysisStay:         rawStats.countTodoDialysisStay ?? 0,
  }
}

export function convertHomeChartStatIn(rawChartStat: HomeChartStatDtoIn): HomeChartStat {
  return {
    ...rawChartStat,
    countValidatedStay: rawChartStat.countTotalStay - rawChartStat.countTodoStay,
  }
}

export function convertPredictionModelIn(rawPredictionModel: PredictionModelDtoIn): PredictionModel {
  return {
    ...rawPredictionModel,
    trainedAt: rawPredictionModel.trainedAt ? dayjs(rawPredictionModel.trainedAt) : null,
  }
}

export function convertHomeStatsOut(payload: HomeStatsPayload): HomeStatsDtoOut {
  return {
    earlyLimit: payload.earlyLimit.format(DATE_FORMAT),
    lateLimit: payload.lateLimit.format(DATE_FORMAT),
    pmsiType: payload.pmsiType,
    hospitalizationTypes: payload.hospitalizationTypes.join(','),
    // le back distingue "pas de filtre" (paramètre absent) d'une liste vide
    ...(payload.medicalUnitIds !== null ? { medicalUnits: payload.medicalUnitIds.join(',') } : {}),
  }
}

export function convertHomeChartStatsOut(payload: HomeChartStatsPayload): HomeChartStatsDtoOut {
  return {
    mode: payload.mode,
    unit: payload.unit,
    earlyLimit: payload.earlyLimit.format(DATE_FORMAT),
    lateLimit: payload.lateLimit.format(DATE_FORMAT),
    ...(payload.medicalUnitIds !== null ? { medicalUnits: payload.medicalUnitIds.join(',') } : {}),
  }
}
